import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import toastr from "toastr";
import "toastr/build/toastr.min.css";

import getCurrentUserId from "../../../../reduxSaga/sagas/requests/currentUserId";

// import { getMonthsAndYears } from "../../../Services/PaiementService";
import {
  uploadCSVFile,
  getFilredUser,
  uploadCSVFileLF,
} from "../../../../services/RHService/AttendanceService";
import withLoader from "../../../../components/layouts/WithLoader";
const AttendanceList = ({ startLoading, stopLoading }) => {
  const [employees, setEmployees] = useState([]);
  const [filter, setFilter] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const [months, setMonths] = useState([]);
  const [years, setYears] = useState([]);

  // const fetchMonthsAndYearsData = async () => {
  //   const data = await getMonthsAndYears();

  //   if (data?.success) {
  //     const { months, years } = data.success;
  //     setMonths(months);
  //     setYears(years);
  //   }
  // };

  // useEffect(() => {
  //   fetchMonthsAndYearsData();
  // }, []);
  const [formData, setFormData] = useState({
    presenceDay: "", // Initialisez-la avec une chaîne vide par défaut
  });

  const handleInputChange = (event) => {
    const target = event.target;
    const name = target.name;
    const value =
      target.type === "checkbox" ? target.checked : target.value.trim();

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  useEffect(() => {
    getFilredUser(getCurrentUserId(), filter)
      .then((data) => {
        setEmployees(data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, [filter]);

  // This code assumes employees is initially an empty array or gets set elsewhere
  const filteredData1 = employees.filter((item) => {
    return (
      item.cin.toLowerCase().includes(filter.toLowerCase()) ||
      item.firstName.toLowerCase().includes(filter.toLowerCase()) ||
      item.lastName.toLowerCase().includes(filter.toLowerCase())
    );
  });

  const [loading, setLoading] = useState("");

  const handleImportCSVFile = async (event) => {
    try {
      // Set loading state to true
      setLoading(true);

      const file = event.target.files[0];

      if (file) {
        const uploadSuccess = await uploadCSVFile(file, getCurrentUserId());

        if (uploadSuccess) {
          const { status, message } = uploadSuccess;

          if (status === "success") {
            toastr.success(message);
          } else {
            toastr.error(message);
          }
        }
      }
    } catch (error) {
      console.error("Error uploading CSV file:", error);
      toastr.error("An error occurred while uploading the CSV file.");
    } finally {
      // Set loading state to false, regardless of success or failure
      setLoading(false);
    }
  };

  const handleImportCSVFileLF = (event) => {
    try {
      // Set loading state to true
      setLoading(true);

      const file = event.target.files[0];

      if (file) {
        startLoading()
        uploadCSVFileLF(file, getCurrentUserId()).then((response) => {
          if (response.data.success) {
            toastr.success("Importation des données avec succée");
          }
        }).catch((error) => {
          toastr.error(error);

        }).finally(() => {
          stopLoading();
        });


      }
    } catch (error) {
      console.error("Error uploading CSV file:", error);
      toastr.error("An error occurred while uploading the CSV file.");
    } finally {
      // Set loading state to false, regardless of success or failure
      setLoading(false);
    }
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">Fiche de Présence </h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <i class="fa-solid fa-house"></i>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active">Fiche de Présence</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div class="card  mt-3">
        <div class="card-body">
          <h5 class="card-title">Importer fichie de présence</h5>
          <br />
          <input
            type="file"
            accept=".xlsx, .xls"
            // className="btn float-right"
            onChange={handleImportCSVFileLF} // Handle file selection
          />
        </div>

      </div>
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-5 col-lg col-sm-12 ">
            <div>
              <label
                htmlFor="excel-import"
                className="excel-import-label float-right mx-3"
              >
                <i class="fa-solid fa-file-csv"></i>
                {loading ? "LOADING..." : " Importer fiche de présence"}
              </label>
              <input
                onChange={handleImportCSVFile}
                type="file"
                id="excel-import"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              />
            </div>
          </div>

          {/* <div class="col-md-5 col-lg col-sm-12 ">
            <div>
              <label
                htmlFor="excel-import"
                className="excel-import-label float-right mx-3"
              >
                <i class="fa-solid fa-file-csv"></i>
                {loading ? "LOADING..." : " Importer fiche de présence deuxième"}
              </label>
              <input
                onChange={handleImportCSVFileLF}
                type="file"
                id="excel-import"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              />
             
            </div>
          </div> */}
        </div>

        <div className="card">
          <div className="row">
            <div className="col-md-2">
              <input
                type="text"
                className="searchTerm mx-3 mt-3 mb-3"
                placeholder="Rechercher..."
                value={filter}
                onChange={(e) => {
                  setFilter(e.target.value);
                  setIsVisible(true);
                }}
              />
            </div>
            {/* <div className="col-md-2">
                <select
                  className="select-box-card1 form-control mx-3 mt-3 mb-3"
                  id="year-select"
                  name="yearSelection"
                  value={formData.month}
                  onChange={handleInputChange}
                >
                  <option className="text-center" value="year">--choisir l'année--</option>
                  {years.map((year, index) => (
                    <option key={index} value={year}>{year}</option>
                  ))}
                </select>
              </div> */}
          </div>
          <div class="card">
            {/* table de mission (set invisible and when tap to search it will visible) */}
            {isVisible &&
              (filteredData1.length === 0 ? (
                <table
                  class="table"
                  style={{ display: filter.length === 0 ? "none" : "table" }}
                >
                  <thead class="thead-dark">
                    <tr>
                      <th scope="col">Personnel</th>
                      <th scope="col">Jour</th>
                      <th scope="col">Date d'entré</th>
                      <th scope="col">Pointages</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th colSpan="7" style={{ textAlign: "center" }}>
                        Pas de résultat, Veuillez vérifier!
                      </th>
                    </tr>
                  </tbody>
                </table>
              ) : (
                <table
                  class="table"
                  style={{ display: filter.length === 0 ? "none" : "table" }}
                >
                  <thead class="thead-dark">
                    <tr>
                      <th scope="col">Personnel</th>
                      <th scope="col">CIN</th>
                      <th scope="col">Jour</th>
                      <th scope="col">Date d'entré</th>
                      <th scope="col">Pointages</th>
                    </tr>
                  </thead>
                  <tbody>
                    {employees.map((employee, index) => (
                      <tr>
                        <td>
                          {employee.firstName} {employee.lastName}
                        </td>
                        <td>{employee.cin}</td>
                        <td>{employee.presenceDay}</td>
                        <td>{employee.realEntryTime}</td>
                        <td>{employee.pointage}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};
export default withLoader(AttendanceList);
